
























































































import Vue from 'vue';
import * as firebase        from 'firebase/app';

import { Repository } from '@/db/_repo';
const db = new Repository();

import * as ping        from '@/lib/usage_ping';
import Modal            from '@/components/Modal.vue';

export default Vue.extend({
    components: {
        Modal
    },
    data() {
        return {
            showModal: false,
            noSubs: false,
            noActiveSubs: false,
            subs: [],
            activeSubs: []
        }
    },
    created() {
        console.log(this.currentUser);
        this.$bind('subs', db.subscriptions.getUserSubs(this.currentUser.uid)).then((val) => {
            if (this.subs.length < 1) {
                this.noSubs = true;
                this.noActiveSubs = true;
            } else {
                this.activeSubs = this.subs.filter(sub => sub.active === true);
                if (this.activeSubs.length < 1) {
                    this.noActiveSubs = true;
                }
            }
        });
    },
    methods: {
        reallyDeleteMe() {
            ping.send({ type: ping.UserUsage.deleteAccount, uid: this.currentUser.uid });
            db.users.deleteUser(this.currentUser.uid)
            .then((val) => {
                this.showModal = false;
                this.$toast.open({
                    message: 'Your user has been scheduled for deletion.  You will now be logged out.',
                    type: 'success',
                    duration: 3000,
                    position: 'top-right'
                });
                setTimeout(() => {
                    firebase.auth().signOut();
                    this.$store.dispatch('setUser', null);
                    this.$router.push('/');
                }, 4500);
            })
            .catch((e) => this.toastAndError(this, 'There was an error. Plesae try again.', e));
        }
    }
});
